import type { RatesRow } from './types'

function Rate({
  label,
  value,
  daysAgo,
}: {
  label: string
  value: number | null
  daysAgo: number | null
}) {
  const stale = daysAgo !== null && daysAgo >= 2
  return (
    <span className="inline-flex items-center gap-1.5 text-sm">
      <span className="text-gray-500">{label}</span>
      <span className={`tabular-nums ${stale ? 'text-amber-700' : 'text-gray-900'}`}>
        {value === null ? '—' : value.toFixed(2)} ₽
      </span>
    </span>
  )
}

export function StatusBar({ rates }: { rates: RatesRow }) {
  return (
    <div className="bg-white rounded-2xl border border-gray-200 px-4 py-2.5 flex items-center gap-4 flex-wrap">
      <Rate label="$" value={rates.usd} daysAgo={rates.usdUpdatedDaysAgo} />
      <Rate label="€" value={rates.eur} daysAgo={rates.eurUpdatedDaysAgo} />
      <Rate label="¥" value={rates.cny} daysAgo={rates.cnyUpdatedDaysAgo} />
    </div>
  )
}
